export default __webpack_public_path__ + "53bc1b7f5147646d4956af8c0c974205.svg";